<template>
    <h1>Deposits</h1>
</template>

<script>
import ErrorHandler from '@/utils/errorHandler'
export default {
    async mounted() {
        try {
            await this.$store.dispatch('GET_ALL_DEPOSTIS')
        } catch (e) {
            new ErrorHandler(e).send
        }
    }
}
</script>